import { useEffect, useState } from "react"
import { Spinner } from "asocomponents"
import DocumentoService from "../../../../modules/Documentos/application/DocumentoService.js";
import GrillaAdjuntos from "./GrillaAdjuntos.jsx";

function GrillaAdjuntoJuicio({ idJuicio }) {

    const [adjuntos, setAdjuntos] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const obtenerDocumentos = async () => {
        setIsLoading(true)
        const documentosServices = new DocumentoService() 

        let documentos = await documentosServices.getDocumentosJuicioS3(idJuicio)

        setAdjuntos(documentos)
        localStorage.setItem("documentos", JSON.stringify(documentos));
        setIsLoading(false)
    } 

    useEffect(() => {
        idJuicio && obtenerDocumentos()
    }, [idJuicio])

    if (isLoading) {
        return <Spinner color="red" size="50" />
    } 

    return (
        <GrillaAdjuntos adjuntos={adjuntos} mostrarBotonAcciones={idJuicio ? true : false}/>
    )
}

export default GrillaAdjuntoJuicio